import { getSession } from "@/auth/session";
import { ApiError, apiFetch } from "@/lib/api-client";
import type { Artifact } from "@/sync/models/artifact";

const apiBaseUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8787";

export type ArtifactVariant = "original" | "thumb" | "meta";

export const uploadArtifact = (projectId: string, file: File) =>
	apiFetch<{ artifact: Artifact }>(
		`/artifacts/upload?projectId=${projectId}&filename=${encodeURIComponent(file.name)}`,
		{
			method: "POST",
			body: file,
			headers: { "Content-Type": file.type || "application/octet-stream" },
		},
	);

export const putArtifactThumbnail = (artifactId: string, thumbnail: Blob) =>
	apiFetch<{ id: string }>(`/artifacts/${artifactId}/thumbnail`, {
		method: "PUT",
		body: thumbnail,
		headers: { "Content-Type": thumbnail.type },
	});

export const artifactFileUrl = (artifactId: string, variant: ArtifactVariant, download = false) =>
	`${apiBaseUrl}/artifacts/${artifactId}/file?variant=${variant}${download ? "&download=1" : ""}`;

/** Authenticated binary fetch (media can't go through `apiFetch`'s JSON parsing). */
export async function fetchArtifactFile(artifactId: string, variant: ArtifactVariant) {
	const session = getSession();
	const res = await fetch(artifactFileUrl(artifactId, variant), {
		headers: {
			...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
			...(session?.workspaceId ? { "X-Workspace-Id": session.workspaceId } : {}),
		},
	});
	if (!res.ok) throw new ApiError(res.status, `Could not load file (${res.status})`);
	return res;
}
